// Lucy & Claire — runtime fixes for AI-generated Shopify blocks.
// Replaces the AI review-banner's CSS marquee with a requestAnimationFrame-
// driven one. iOS Safari aggressively pauses long CSS transform animations
// on real devices (not in DevTools mobile mode); rAF avoids that path
// entirely.
(function () {
  'use strict';

  var PX_PER_SEC_MOBILE = 35; // ~35px/s on phones
  var PX_PER_SEC_DESKTOP = 60;

  function findMarquees() {
    return document.querySelectorAll('[class*="ai-review-banner-reviews-"]');
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  // The AI block ships with the unique cards already duplicated once
  // (so 8 unique × 2 = 16 visible children). We duplicate them once more
  // so we have 4× the unique cards, which means we can loop by snapping
  // back at -50% of the total width — visually seamless because the
  // duplicated halves are identical.
  function ensureDuplicated(row) {
    if (row.dataset.lcDuplicated === '1') return;
    var originals = Array.prototype.slice.call(row.children);
    if (originals.length === 0) return;
    originals.forEach(function (child) {
      row.appendChild(child.cloneNode(true));
    });
    row.dataset.lcDuplicated = '1';
  }

  function startMarquee(row) {
    if (row.dataset.lcRafRunning === '1') return;
    row.dataset.lcRafRunning = '1';

    // Kill the AI block's CSS animation — we drive transforms ourselves.
    row.style.animation = 'none';
    row.style.willChange = 'transform';

    var pos = 0;
    var paused = false;
    var lastTime = 0;

    function onEnter() { paused = true; }
    function onLeave() { paused = false; }
    row.addEventListener('mouseenter', onEnter);
    row.addEventListener('mouseleave', onLeave);
    row.addEventListener('touchstart', onEnter, { passive: true });
    row.addEventListener('touchend', onLeave, { passive: true });

    function tick(now) {
      if (!lastTime) lastTime = now;
      var dt = now - lastTime;
      lastTime = now;

      // Cap dt — if the page was backgrounded for minutes, don't jump-warp.
      if (dt > 500) dt = 16;

      if (!paused) {
        var speed = isMobile() ? PX_PER_SEC_MOBILE : PX_PER_SEC_DESKTOP;
        var halfWidth = row.scrollWidth / 2;
        if (halfWidth > 0) {
          pos -= (speed * dt) / 1000;
          // Seamless loop: snap back when we've moved one full unique set.
          while (pos <= -halfWidth) pos += halfWidth;
          row.style.transform = 'translate3d(' + pos + 'px, 0, 0)';
        }
      }

      requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  function initAll() {
    findMarquees().forEach(function (row) {
      ensureDuplicated(row);
      startMarquee(row);
    });
  }

  function init() {
    initAll();

    // Re-check periodically in case the AI block was injected after
    // initial DOM ready (deferred-load app blocks).
    var attempts = 0;
    var poll = setInterval(function () {
      initAll();
      attempts += 1;
      if (attempts >= 15) clearInterval(poll);
    }, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
